export default __webpack_public_path__ + "static/media/capacitor-panel.c6b9d557.jpg";